module.exports = __webpack_public_path__ + "img/banner.04f01d5c.jpg";